/// <reference path="cfncstorage.ts" />
/// <reference path="../../node_modules/oidc-client/dist/oidc-client.d.ts" />

module Cfnc.Security {
    export interface IAuthenticationService {
        user: any;
        login(): Promise<void>;
        register(): Promise<void>;
        logout(setReturnPath?: boolean): Promise<void>;
        completeLogout(): Promise<Oidc.SignoutResponse>;
        changePassword(data: any): ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        authenticate(updateRedirect?: boolean): ng.IPromise<boolean>;
        redirectAuthenticated(url?: string, removeQueryParams?: boolean): void;
        //getUser(): IUserInfoView;
        safeAccessToken: () => Promise<string>;
        broadcastLogin: () => void;
        checkLogin: () => Promise<any>;
        xapLogout: () => void;
        redirect: (url?: string, removeQueryParams?: boolean) => void;
        clearRedirect: () => void;
        completeLogin: () => Promise<Oidc.User>;
        isLoggedIn: () => Promise<boolean>;
        silentLogout: () => Promise<void>;
        providerUrls: IAuthenticationProviderUrls;
    }

    export class AuthenticationService implements IAuthenticationService {
        private externalLoginWindowTimer: any;
        oidcUser: Oidc.User;
        user: IUserInfoView;
        externalUser: any;
        externalLogins: Array<any>;
        providerUrls: IAuthenticationProviderUrls;

        timeoutModalInstance: ng.ui.bootstrap.IModalServiceInstance;
        pageTitle: string;
        private redirectUrl: string;
        private readonly _userManager: Oidc.UserManager;
        private checkingLogin: boolean = false;
        private loginCheckComplete: ng.IAngularEvent;

        constructor(private api: IAccountService,
            private authProvider: AuthenticationProvider,
            private $rootScope: ICfncRootScope,
            private $q: ng.IQService,
            private $http: ng.IHttpService,
            private $location: ng.ILocationService,
            private $timeout: ng.ITimeoutService,
            private $window: ng.IWindowService,
            private $cookies: ng.cookies.ICookiesService,
            private $uibModal: ng.ui.bootstrap.IModalService,
            private $routeParams,
            private Idle,
            private Title,
            private config: IConfig
        ) {

            $rootScope.$on('IdleStart', () => {
                this.pageTitle = this.Title.original();
                this.timeoutModalInstance = this.$uibModal.open({
                    templateUrl: '/app/login/logoutModal.html',
                    controller: 'logoutModal',
                    backdrop: 'static',
                    resolve: {
                        data: function () { }
                    }
                });
            });

            $rootScope.$on('IdleEnd', () => {
                this.timeoutModalInstance.close();
                this.Title.store(true);
                this.Title.original(this.pageTitle);
            });

            $rootScope.$on('IdleTimeout', () => {
                this.timeoutModalInstance.close();
                this.logout(true);
            });
     
            const authSettings = {
                authority: authProvider.providerUrls.authority,
                client_id: authProvider.clientId,
                redirect_uri: authProvider.providerUrls.redirect_uri,
                scope: "openid profile email cfncapi cfncdata",
                response_type: "code",
                post_logout_redirect_uri: authProvider.providerUrls.post_logout_redirect_uri,
                automaticSilentRenew: true,
                silent_redirect_uri: authProvider.providerUrls.silent_redirect_uri
            };

            this._userManager = new Oidc.UserManager(authSettings);
            this._userManager.events.addUserSignedOut(this.completeLogout);

            this.providerUrls = this.authProvider.providerUrls;

            this.initialize();
        }

        $broadcast(...params: Array<any>): any {
            return this.$rootScope.$broadcast.apply(this.$rootScope, params);
        }


        accessToken(): string {
            return this.oidcUser ? this.oidcUser.access_token : null;
        }

        completeLogin() {
            return this._userManager.signinRedirectCallback().then(user => {
                this.oidcUser = user;
                this.user = {
                    userName: user.profile.name,
                    firstName: user.profile.given_name,
                    lastName: user.profile.family_name,
                    primaryConnection: user.profile.primaryConnectionId
                };
                if (appInsights && appInsights.setAuthenticatedUserContext) {
                    appInsights.setAuthenticatedUserContext(user.profile.email);
                }
                if (this.authProvider.events.login) {
                    this.$broadcast(this.authProvider.events.login, user);
                }
                this.$http.defaults.headers.common.Authorization = "Bearer " + user.access_token;
                this.Idle.watch();
                return user;
            });
        }

        isLoggedIn(): Promise<boolean> {
            var defer = this.$q.defer<boolean>();
            var check = () => {
                this._userManager.getUser().then(user => {
                    const userCurrent = !!user && !user.expired;
                    this.oidcUser = user;
                    if (userCurrent) {
                        this.$http.defaults.headers.common.Authorization = "Bearer " + user.access_token;
                    }

                    defer.resolve(userCurrent);
                });
            };

            
            if (this.checkingLogin) {
                this.$rootScope.$on(this.authProvider.events.loginCheckCompleted, check);
            }
            else {
                check();
            }

            return defer.promise;
        }

        completeLogout = () => {
            return this._userManager.removeUser().then(() => {
                this.user = null;
                this.oidcUser = null;
                this.$http.defaults.headers.common.Authorization = null;
                this.$broadcast(this.authProvider.events.logout);
                return this._userManager.signoutRedirectCallback();
            })
        }

        // The forceLogin parameter is there to allow the RDS side to use the function and
        // still require login
        checkLogin = (forceLogin?: boolean): Promise<any> => {
            this.checkingLogin = true;
            return this._userManager.signinSilent().then((user) => {
                this.Idle.watch();
                this.oidcUser = user;
                this.user = {
                    userName: user.profile.name,
                    firstName: user.profile.given_name,
                    lastName: user.profile.family_name,
                    primaryConnection: user.profile.primaryConnectionId
                };
                if (appInsights && appInsights.setAuthenticatedUserContext) {
                    appInsights.setAuthenticatedUserContext(user.profile.name);
                }
                if (this.authProvider.events.login) {
                    this.$broadcast(this.authProvider.events.login, this.user);
                }
                this.$broadcast(this.authProvider.events.loginCheckCompleted);
                this.checkingLogin = false;
                return user;
            }, () => {
                    this.$broadcast(this.authProvider.events.loginCheckCompleted);
                    this.checkingLogin = false;
            });

        };

        safeAccessToken(): Promise<string> {
            return this._userManager.getUser().then(user => {
                if (!!user && !user.expired) {
                    return user.access_token;
                } else {
                    return null;
                }
            });
        }

        private initialize(): void {
            if (this.$location.path() != "/logout") {
                this.checkLogin(false).then((user) => {
                    if (this.authProvider.events.reloadUser) {
                        this.$broadcast(this.authProvider.events.reloadUser, user);
                    }
                });
            }
        }

        private redirectTarget(newTarget?: string): string {
            if (newTarget === "clear" || (localStorage[CfncStorage.redirectTarget] || "").toLowerCase() === "/login") {
                localStorage.removeItem(CfncStorage.redirectTarget);
                return;
            }
            if (newTarget) {
                localStorage[CfncStorage.redirectTarget] = newTarget;
            }
            return localStorage[CfncStorage.redirectTarget];
        }

        public clearRedirect() {
            this.redirectTarget("clear");
        }

        public login(): Promise<void> {
            this.redirectTarget(this.$location.path());
            return this._userManager.signinRedirect();
        }

        public register(): Promise<void> {
            this.redirectTarget(this.$location.path());
            return this._userManager.createSigninRequest().then(sr => {
                var signInUrl = sr.url;
                var redirectUrl = this.authProvider.providerUrls.register + "?returnUrl=" + encodeURIComponent(signInUrl);
                this.redirect(redirectUrl)
            });
        }

        public logout(setReturnPath?: boolean): Promise<void> {
            this.Idle.unwatch();
            if (setReturnPath && this.$location.path() != this.authProvider.providerUrls.login) {
                this.redirectTarget(this.$location.path());
            }
            else if (!setReturnPath && this.$location.path() != this.authProvider.providerUrls.login) {
                this.redirectTarget("clear");
            }

            return this._userManager.signoutRedirect();
        }

        public silentLogout(): Promise<void> {
            return this._userManager.removeUser();
        }

        public changePassword(data): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> {
            var deferred: ng.IDeferred<any> = this.$q.defer();

            this.api.changePassword(data).then(result => {
                deferred.resolve();
            }, reason => {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        public authenticate = (updateRedirect?: boolean): ng.IPromise<boolean> => {
            var deferred = this.$q.defer<boolean>();
            this.isLoggedIn().then((loggedIn) => {
                if (loggedIn) {
                    this.$rootScope.$on(this.config.events.logout, (event) => {
                        this.logout(true);
                    });

                    deferred.resolve(loggedIn);
                } else {
                    this.login().then(() => {
                        deferred.resolve(true);
                    });
                }
            });

            return deferred.promise;
        };

        public redirectAuthenticated(url?: string, removeQueryParams?: boolean): void {
            var redirectUrl = url || this.redirectTarget() || this.authProvider.providerUrls.home;

            if (this.redirectTarget()) {
                this.redirectTarget("clear");
            }

            if (this.authProvider.useFullRefreshForRedirect || redirectUrl.indexOf("http") === 0) {
                this.$window.location.href = redirectUrl;
            } else {
                if (removeQueryParams) {
                    this.$location.search({});
                }
                this.$location.path(redirectUrl);
                this.$rootScope.$apply();
            }
        }

        public broadcastLogin() {
            var expiresInterval = moment(localStorage[CfncStorage.expiresOn]).diff(moment(Date.now()));
            this.$broadcast(this.authProvider.events.login, this.user);
        }

        public xapLogout(): void {
            this.api.xapLogout();
        }

        redirect(url?: string, removeQueryParams?: boolean): void {
            if (url) {
                this.redirectUrl = url;
            }

            if (this.redirectUrl) {
                if (this.isExternal(this.redirectUrl)) {
                    this.$window.location.href = this.redirectUrl;
                } else {
                    if (removeQueryParams) {
                        this.$location.search({});
                    }
                    this.$location.url(this.redirectUrl);
                    this.$rootScope.$apply();
                }
                this.clear();
            } else {
                if (removeQueryParams) {
                    this.$location.search({});
                }
                this.$location.path(this.authProvider.providerUrls.home);
                this.$rootScope.$apply();
            }

        }

        clear(): void {
            this.redirectUrl = null;
        }

        isExternal(url): boolean {
            var regex = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
            var test = regex.exec(url);

            return test !== null && test[1] !== this.$location.host();
        }
    }
}
